<template>
  <div>Logout...</div>
</template>

<script>
export default {
  methods: {},
  beforeMount: function() {
    const loading = this.$loading({
      lock: true,
      text: "Logout...",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)"
    });
    setTimeout(() => {
      this.$store
        .dispatch("logout")
        .then(() => {
          this.$router.push("/authorization");
          loading.close();
        })
        .catch(error => {
          this.errorDescription = error;
          loading.close();
        });
    }, 2000);
  }
};
</script>
